import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './Admin/AdminDashboard';
import TenantList from './Admin/TenantList';
import TenantDetail from './Admin/TenantDetail';
import TenantEditor from './Admin/TenantEditor';

const Admin = () => {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />
      <Route path="tenants" element={<TenantList />} />
      <Route path="tenants/:id/*" element={<TenantDetail />} />
      <Route path="tenants/new" element={<TenantEditor />} />
      <Route path="*" element={<Navigate to="tenants" />} />
    </Routes>
  );
};



export default Admin;
